const CrmInteractionsFilters = [
  {
    name: 'Type',
    pages: ['CrmInteractions'],
    searchState: 'always',
    filterName: 'interactionType',
    prefix: 'type',
    options: [
      { name: 'Email' },
      { name: 'Meeting' },
      { name: 'Phone call' },
      { name: 'Social media' },
      { name: 'Events' },
      { name: 'Other' },
    ],
  },
  {
    name: 'Initiator',
    pages: ['CrmInteractions'],
    searchState: 'always',
    filterName: 'initiator',
    prefix: 'initiator',
    notSendIfOptionsAreSelected: true,
    options: [
      { name: '${team.teamName}', filter: [{ field: 'initiatedByOrganisation', value: 'true', operator: 'str_eq' }] },
      { name: 'Stakeholder', filter: [{ field: 'initiatedByOrganisation', value: 'false', operator: 'str_eq' }] },
    ],
  },
  {
    name: 'People',
    pages: ['CrmInteractions'],
    searchState: 'always',
    filterName: 'stakeholderContactIds',
    prefix: 'people',
    type: 'membership',
    subtype: 'CrmContacts',
    options: [],
  },
];

export default CrmInteractionsFilters;
